export interface MarketingAdditionalItems{
    itemDetails: AdditionalItemDetail[];
}

export interface AdditionalItemDetail{
    description: string;
    cost: number;
    currencyType: string;
}